import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2290fe9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-lg w-175 py-20 px-40 space-y-12" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-20 h-28 mx-auto",
    src: "/icons/dark_temp.svg"
  })
], -1))
const _hoisted_4 = { class: "w-full flex flex-col opacity-80 space-y-2" }
const _hoisted_5 = {
  class: "font-semibold text-lg",
  for: "email"
}
const _hoisted_6 = { class: "w-full flex flex-col space-y-2" }
const _hoisted_7 = {
  class: "font-semibold text-lg opacity-80",
  for: "password"
}
const _hoisted_8 = { class: "mx-auto w-full" }
const _hoisted_9 = { class: "mx-auto w-full" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-48",
  alt: "Google sign-in",
  src: "/images/btn_google_signin_dark_normal_web.png"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomButton = _resolveComponent("CustomButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('auth_login_header')), 1),
    _hoisted_3,
    _createElementVNode("form", {
      class: "flex flex-col space-y-8",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('auth_login_email')), 1),
        _withDirectives(_createElementVNode("input", {
          id: "email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
          autocomplete: "email",
          class: "border border-gray-300 p-3 rounded-lg",
          type: "email"
        }, null, 512), [
          [_vModelText, _ctx.form.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('auth_login_password')), 1),
        _withDirectives(_createElementVNode("input", {
          id: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
          autocomplete: "password",
          class: "border border-gray-300 p-3 rounded-lg font-black tracking-widest",
          type: "password"
        }, null, 512), [
          [_vModelText, _ctx.form.password]
        ])
      ]),
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$router.push({ name: 'Signup' })))
      }, _toDisplayString(_ctx.$t('auth_login_noAccount')), 1),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_CustomButton, {
          type: "submit",
          class: "w-full px-6 text-lg"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('auth_login_btnLogin')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          class: "btn btn-outline-dark",
          href: "#",
          role: "button",
          style: {"text-transform":"none"},
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.googleLogin()))
        }, _hoisted_11)
      ])
    ], 32)
  ]))
}